import React, { useState } from "react";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";
import { useNavigate, Link } from "react-router-dom";
import { getFirestore, doc, getDoc, updateDoc } from "firebase/firestore";
import Button from "../components/ui/Button";
import Card from "../components/ui/Card";
import { theme } from "../styles/theme";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [validationCode, setValidationCode] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const db = getFirestore();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    try {
      // Verificar se o código de validação é válido
      const codeDoc = await getDoc(doc(db, "validationCodes", validationCode.trim())); 
      if (!codeDoc.exists()) {
        setError("Código de validação inválido.");
        setLoading(false);
        return;
      }

      const codeData = codeDoc.data();
      if (codeData.used) {
        setError("Este código já foi usado.");
        setLoading(false);
        return;
      }

      // Criar usuário no Firebase Authentication
      await createUserWithEmailAndPassword(auth, email, password);

      // Marcar o código como usado no Firestore
      await updateDoc(doc(db, "validationCodes", validationCode), { used: true });

      setSuccess("Registro realizado com sucesso! Redirecionando...");

      // Redirecionar para login após 3 segundos
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      console.error("Erro ao registrar usuário:", error.message);
      setError("Erro ao registrar. Verifique suas informações e tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: `linear-gradient(135deg, ${theme.colors.primary}15, ${theme.colors.secondary}15)`,
        display: "flex",
      alignItems: "center",
        justifyContent: "center",
      padding: theme.spacing.xl,
      fontFamily: theme.typography.fontFamily.primary,
    }}>
      <div style={{
          width: "100%",
        maxWidth: window.innerWidth < 768 ? "95%" : "450px",
        padding: window.innerWidth < 768 ? theme.spacing.md : 0,
      }}>
        {/* Header */}
        <div style={{
          textAlign: "center",
          marginBottom: theme.spacing['2xl'],
        }}>
          <h1 style={{
            fontSize: theme.typography.fontSize['3xl'],
            fontWeight: theme.typography.fontWeight.bold,
            color: theme.colors.gray[800],
            marginBottom: theme.spacing.sm,
          }}>
          Criar Conta
          </h1>
          <p style={{
            fontSize: theme.typography.fontSize.lg,
            color: theme.colors.gray[600],
            marginBottom: theme.spacing.md,
          }}>
            Junte-se ao Draiva e comece seus testes
          </p>
          
          {/* Payment Info Card */}
          <div style={{
            backgroundColor: `${theme.colors.primary}10`,
            border: `1px solid ${theme.colors.primary}30`,
            borderRadius: theme.borderRadius.lg,
            padding: theme.spacing.lg,
            marginBottom: theme.spacing.lg,
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: theme.spacing.sm,
              marginBottom: theme.spacing.sm,
            }}>
              <span style={{ fontSize: theme.typography.fontSize.xl }}>💰</span>
              <span style={{
                fontSize: theme.typography.fontSize.lg,
                fontWeight: theme.typography.fontWeight.bold,
                color: theme.colors.primary,
              }}>
                Subscrição: 99MT
              </span>
            </div>
            <p style={{
              fontSize: theme.typography.fontSize.sm,
              color: theme.colors.gray[600],
              marginBottom: theme.spacing.sm,
            }}>
              Envie o valor para o M-Pesa <strong>842566731</strong>
            </p>
            <p style={{
              fontSize: theme.typography.fontSize.sm,
              color: theme.colors.gray[600],
              marginBottom: theme.spacing.sm,
            }}>
              Ou
            </p>
            <p style={{
              fontSize: theme.typography.fontSize.sm,
              color: theme.colors.gray[600],
              marginBottom: theme.spacing.sm,
            }}>
              Envie o valor para o E-Mola <strong>867764830</strong>
            </p>
            <p style={{
              fontSize: theme.typography.fontSize.sm,
              color: theme.colors.gray[600],
              marginBottom: theme.spacing.md,
            }}>
              Envie o comprovativo para obter seu código de validação
            </p>
            <a
              href="https://wa.me/258842566731?text=Olá! Gostaria de enviar o comprovativo do pagamento para obter o código de validação."
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: theme.spacing.sm,
                backgroundColor: "#25D366",
                color: theme.colors.white,
                padding: `${theme.spacing.sm} ${theme.spacing.md}`,
                borderRadius: theme.borderRadius.md,
                textDecoration: "none",
                fontWeight: theme.typography.fontWeight.medium,
                fontSize: theme.typography.fontSize.sm,
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.05)";
                e.target.style.boxShadow = "0 4px 12px rgba(37, 211, 102, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "none";
              }}
            >
              <span style={{ fontSize: "1.2em" }}>📱</span>
              Enviar Comprovativo via WhatsApp
            </a>
          </div>
        </div>

        {/* Register Form */}
        <Card variant="elevated" padding="xl">
        <form onSubmit={handleSubmit}>
            {/* Email Field */}
            <div style={{ marginBottom: theme.spacing.lg }}>
            <label
              htmlFor="email"
              style={{
                display: "block",
                  fontSize: theme.typography.fontSize.sm,
                  fontWeight: theme.typography.fontWeight.semibold,
                  color: theme.colors.gray[700],
                  marginBottom: theme.spacing.sm,
              }}
            >
                E-mail
            </label>
              <div style={{ position: "relative" }}>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
                  placeholder="seu@email.com"
              style={{
                width: "100%",
                    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
                    border: `1px solid ${theme.colors.gray[300]}`,
                    borderRadius: theme.borderRadius.lg,
                    fontSize: theme.typography.fontSize.base,
                    fontFamily: theme.typography.fontFamily.primary,
                    transition: theme.transitions.normal,
                    backgroundColor: theme.colors.white,
                    boxSizing: "border-box",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = theme.colors.primary;
                    e.target.style.boxShadow = `0 0 0 3px ${theme.colors.primary}20`;
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = theme.colors.gray[300];
                    e.target.style.boxShadow = "none";
                  }}
                />
                <div style={{
                  position: "absolute",
                  right: theme.spacing.md,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: theme.colors.gray[400],
                }}>
                  📧
                </div>
              </div>
          </div>

            {/* Password Field */}
            <div style={{ marginBottom: theme.spacing.lg }}>
            <label
              htmlFor="password"
              style={{
                display: "block",
                  fontSize: theme.typography.fontSize.sm,
                  fontWeight: theme.typography.fontWeight.semibold,
                  color: theme.colors.gray[700],
                  marginBottom: theme.spacing.sm,
              }}
            >
                Senha
            </label>
              <div style={{ position: "relative" }}>
            <input
              id="password"
                  type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
                  placeholder="••••••••"
              style={{
                width: "100%",
                    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
                    paddingRight: "3rem",
                    border: `1px solid ${theme.colors.gray[300]}`,
                    borderRadius: theme.borderRadius.lg,
                    fontSize: theme.typography.fontSize.base,
                    fontFamily: theme.typography.fontFamily.primary,
                    transition: theme.transitions.normal,
                    backgroundColor: theme.colors.white,
                    boxSizing: "border-box",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = theme.colors.primary;
                    e.target.style.boxShadow = `0 0 0 3px ${theme.colors.primary}20`;
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = theme.colors.gray[300];
                    e.target.style.boxShadow = "none";
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    right: theme.spacing.md,
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: theme.colors.gray[400],
                    fontSize: theme.typography.fontSize.lg,
                    padding: theme.spacing.xs,
                    borderRadius: theme.borderRadius.sm,
                    transition: theme.transitions.normal,
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = theme.colors.gray[100];
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                  }}
                >
                  {showPassword ? "🙈" : "👁️"}
                </button>
              </div>
          </div>

            {/* Validation Code Field */}
            <div style={{ marginBottom: theme.spacing.lg }}>
            <label
              htmlFor="validationCode"
              style={{
                display: "block",
                  fontSize: theme.typography.fontSize.sm,
                  fontWeight: theme.typography.fontWeight.semibold,
                  color: theme.colors.gray[700],
                  marginBottom: theme.spacing.sm,
              }}
            >
                Código de Validação
            </label>
              <div style={{ position: "relative" }}>
            <input
              id="validationCode"
              type="text"
              value={validationCode}
              onChange={(e) => setValidationCode(e.target.value)}
              required
                  placeholder="Digite seu código"
              style={{
                width: "100%",
                    padding: `${theme.spacing.md} ${theme.spacing.lg}`,
                    border: `1px solid ${theme.colors.gray[300]}`,
                    borderRadius: theme.borderRadius.lg,
                    fontSize: theme.typography.fontSize.base,
                    fontFamily: theme.typography.fontFamily.primary,
                    transition: theme.transitions.normal,
                    backgroundColor: theme.colors.white,
                    boxSizing: "border-box",
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = theme.colors.primary;
                    e.target.style.boxShadow = `0 0 0 3px ${theme.colors.primary}20`;
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = theme.colors.gray[300];
                    e.target.style.boxShadow = "none";
                  }}
                />
                <div style={{
                  position: "absolute",
                  right: theme.spacing.md,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: theme.colors.gray[400],
                }}>
                  🔑
                </div>
              </div>
          </div>

            {/* Error Message */}
          {error && (
              <div style={{
                backgroundColor: `${theme.colors.error}10`,
                border: `1px solid ${theme.colors.error}30`,
                color: theme.colors.error,
                padding: theme.spacing.md,
                borderRadius: theme.borderRadius.md,
                marginBottom: theme.spacing.lg,
                fontSize: theme.typography.fontSize.sm,
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.sm,
              }}>
                <span>⚠️</span>
                {error}
              </div>
            )}

            {/* Success Message */}
          {success && (
              <div style={{
                backgroundColor: `${theme.colors.success}10`,
                border: `1px solid ${theme.colors.success}30`,
                color: theme.colors.success,
                padding: theme.spacing.md,
                borderRadius: theme.borderRadius.md,
                marginBottom: theme.spacing.lg,
                fontSize: theme.typography.fontSize.sm,
                display: "flex",
                alignItems: "center",
                gap: theme.spacing.sm,
              }}>
                <span>✅</span>
                {success}
              </div>
            )}

            {/* Submit Button */}
            <Button
            type="submit"
              variant="primary"
              size="lg"
              loading={loading}
              fullWidth
              style={{ marginBottom: theme.spacing.lg }}
            >
              {loading ? "Registrando..." : "Criar Conta"}
            </Button>
          </form>

          {/* Divider */}
          <div style={{
            display: "flex",
            alignItems: "center",
            margin: `${theme.spacing.lg} 0`,
          }}>
            <div style={{
              flex: 1,
              height: "1px",
              backgroundColor: theme.colors.gray[200],
            }} />
            <span style={{
              padding: `0 ${theme.spacing.md}`,
              color: theme.colors.gray[500],
              fontSize: theme.typography.fontSize.sm,
            }}>
              ou
            </span>
            <div style={{
              flex: 1,
              height: "1px",
              backgroundColor: theme.colors.gray[200],
            }} />
          </div>

          {/* Login Link */}
          <div style={{ textAlign: "center" }}>
            <p style={{
              fontSize: theme.typography.fontSize.base,
              color: theme.colors.gray[600],
              marginBottom: theme.spacing.md,
            }}>
              Já tem uma conta?
            </p>
            <Link to="/login" style={{ textDecoration: "none" }}>
              <Button variant="outline" fullWidth>
                Fazer Login
              </Button>
            </Link>
          </div>
        </Card>

        {/* Footer */}
        <div style={{
          textAlign: "center",
          marginTop: theme.spacing.xl,
          color: theme.colors.gray[500],
          fontSize: theme.typography.fontSize.sm,
        }}>
          <p>
            Ao criar uma conta, você concorda com nossos{" "}
            <span style={{ color: theme.colors.primary, cursor: "pointer" }}>
              Termos de Serviço
            </span>{" "}
            e{" "}
            <span style={{ color: theme.colors.primary, cursor: "pointer" }}>
              Política de Privacidade
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
